<!--
 * @Description: 银行信息
 * @Date: 2025-09-12 17:45:57
-->
<template>
  <BaseTextTitle>银行信息</BaseTextTitle>
  <BaseTextContent>
    <BaseForm label-position="top" disabled :model="formData" :column-count="4">
      <BaseFormItem
        label="开户银行"
        prop="operator"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          v-model="formData.bankInfo"
        />
      </BaseFormItem>
      <!-- 没有，产品说空着 -->
      <BaseFormItem label="开户名" prop="">
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          value=""
        />
      </BaseFormItem>
      <BaseFormItem
        label="银行账号"
        prop="bankCardNum"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          clearable
          v-model="formData.bankCardNum"
        />
      </BaseFormItem>
    </BaseForm>
  </BaseTextContent>
</template>

<script lang="ts" setup>
import {
  BaseFormItem,
  BaseInput,
  BaseTextContent,
  BaseTextTitle,
  BaseForm
} from 'xrk-components';
import { IndividualInfoDetailData } from '../../data-source/types';

const formData = defineModel<IndividualInfoDetailData>();
</script>
